import React from "react";
import styles from "./webtemplates.module.scss";
import { RxCross2 } from "react-icons/rx";

function WebTemplates({ closeChooseTemplatecontainer }) {
    const templates = [
        {
            id: 1,
            name: "Default template",
            desc: "Default portfolio style",
            type: "Free",
            price: "0 ₹",
            showCaseUrl: "",
            previewImg: "",
            isPurchased: true,
        },

        {
            id: 2,
            name: "Crazy Template",
            desc: "Paid portfolio style",
            type: "Paid",
            price: "150 ₹",
            showCaseUrl: "",
            previewImg: "",
            isPurchased: false,
        },

        {
            id: 3,
            name: "Crazy Template",
            desc: "Paid portfolio style",
            type: "Paid",
            price: "150 ₹",
            showCaseUrl: "",
            previewImg: "",
            isPurchased: false,
        },

        {
            id: 4,
            name: "Crazy Template",
            desc: "Paid portfolio style",
            type: "Paid",
            price: "150 ₹",
            showCaseUrl: "",
            previewImg: "",
            isPurchased: false,
        },
    ];

    const handleModalClosure = () => {
        closeChooseTemplatecontainer(false)
    }
    return (
        <div className="container-background content-center">
            <div className={styles.templateContainer}>
                <div className={styles.closBtn} title="Close" onClick={handleModalClosure}>
                    <RxCross2 />
                </div>
                <div className={styles.containerHeader}>
                    <h3>Portfolio Templates</h3>
                    <p>
                        Kickstart your business with a template built for Drone Pilots,
                        Photographers etc.
                    </p>
                </div>

                <div className={styles.containerBody}>
                    {templates.map((template) => (
                        <div
                            key={template.id}
                            className={`${template.isPurchased && styles.selectedTemplate} ${styles.templates
                                }`}
                        >
                            <div className={styles.templateMedia}>
                                <img src={template.img} alt="preview" />
                                <div className={styles.templateType}>{template.type}</div>
                            </div>
                            <div className={styles.templateContent}>
                                <div className={styles.templateDetail}>
                                    <h4>{template.name}</h4>
                                    <p>{template.desc}</p>
                                </div>
                                <div className={styles.templatePrice}>{template.price}</div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className={styles.btnContainer}>
                    <button className="">Cancel</button>
                    <button className="">Save</button>
                </div>
            </div>
        </div>
    );
}

export default WebTemplates;
